<script setup>
import { onMounted } from 'vue'
import { onAuthStateChanged } from '@firebase/auth'
import { useUserStore } from '@/store/user'
import { useRouter } from 'vue-router'
import { isStaging } from '@//helpers/environment'
import { initializePaddle } from '@//helpers/paddle.js'
import LegalsFooter from '@/components/atoms/LegalsFooter.vue'
import { auth } from '@/plugins/firebase'
import { useOnboardingStore } from './store/onboarding'

const router = useRouter()

onMounted(() => {
  initializePaddle()
  const onboardingStore = useOnboardingStore()
  const userStore = useUserStore()
  
  onboardingStore.fetchFlowDetails()

  onAuthStateChanged(auth, async (user) => {
    if (isStaging) {
      console.log('::USER::', user)
    }
    if (user) {
      localStorage.setItem('cdw_iuli', true)
      userStore.setUser(user, false, router.options.history.state.current)
    } else {
      localStorage.removeItem('cdw_iuli')
      userStore.setUser(null)
    }
  })
})
</script>

<template>
  <metainfo>
    <template v-if="content" v-slot:title="{ content }">{{ content }}</template>
  </metainfo>
  <div class="app-container">
    <router-view></router-view>
    <LegalsFooter />
  </div>
</template>

<style>
.app-container {
  position: absolute;
  inset: 0;
  display: flex;
  min-height: 100dvh;
  flex-direction: column;
}
</style>